<template>
  <import-charge-tab lob="AI" />
</template>

<script>
import importChargeTab from '@/components/Cargo/Job/importCharge/importChargeTab'

export default {
  name: 'ImportChargeAI',
  components: { importChargeTab }
}
</script>
